import { combineReducers } from 'redux';

const sessionReducer = (state = {}, action) => {
  switch (action.type) {
  case 'session':return action.body;
  default:return { ...state };
  }
};
const psdReducer = (state = {}, action) => {
  const body = JSON.parse(JSON.stringify(state));
  switch (action.type) {
  case 'PSD_post':body[action.label] = action.body; return body;
  case 'PSD_clear':delete body[action.label]; return body;
  default:return { ...state };
  }
};
const jwtReducer = (state = {}, action) => {
  const body = JSON.parse(JSON.stringify(state));
  switch (action.type) {
  case 'JWT_post':body[action.label] = action.body; return body;
  case 'JWT_clear':delete body[action.label]; return body;
  default:return { ...state };
  }
};

const dataReducer = (state = {}, action) => {
  const body = JSON.parse(JSON.stringify(state));
  switch (action.type) {
  case 'post':body[action.label] = action.body; return body;
  case 'clear':delete body[action.label]; return body;
  default:return { ...state };
  }
};

const treeWidthReducer = (state = 0, action) => {
  switch (action.type) {
  case 'treeWidth': return action.value;
  default:return state;
  }
};

const isManageReducer = (state = false, action) => {
  switch (action.type) {
  case 'setIsManage': return action.value;
  default:return state;
  }
};

const loading = (state = [], action) => {
  switch (action.type) {
  case 'loading_add': state.push(action.value); break;
  case 'loading_del': if (state.indexOf('action.label' > -1))state.splice(state.indexOf(action.value), 1); break;
  case 'post': if (state.indexOf('action.label' > -1)) state.splice(state.indexOf(action.label), 1); break;
  default: break;
  }
  return [...state];
};

const allReducers = combineReducers({
  session: sessionReducer,
  PSD: psdReducer,
  JWT: jwtReducer,
  data: dataReducer,
  treeWidth: treeWidthReducer,
  isManage: isManageReducer,
  loading,
});

export default allReducers;
